<div class="flex flex-col gap-(--gap-normal) p-(--padding-card)">
  <div class="flex items-center gap-(--gap-tight) p-(--space-2) bg-amber-50 border border-amber-200 rounded-(--radius-md)">
    <span class="material-symbols text-amber-600 text-base leading-none">warning</span>
    <span class="text-xs text-amber-800">{{ conflictsWarning() }}</span>
  </div>

  <div class="overflow-y-auto max-h-[60vh]">
    <table class="w-full border-collapse text-sm table-fixed">
      <colgroup>
        <col class="w-[40%]" />
        <col class="w-[30%]" />
        <col class="w-[30%]" />
      </colgroup>
      <thead class="sticky top-0 bg-(--surface-0) z-10 shadow-[0_1px_0_var(--border)]">
        <tr>
          <th class="text-left py-2 px-3 font-semibold text-(color:--text-secondary)">
            {{ 'entities.campaign.merge.measure' | transloco }}
          </th>
          <th class="text-right py-2 px-3 font-semibold text-(color:--text-secondary)">
            <div>{{ headerA() }}</div>
            @if (!isImport()) {
              <div class="font-normal text-(color:--text-primary) tabular-nums">{{ dateA() }}</div>
            }
            <button
              type="button"
              class="text-xs font-normal text-(--primary) underline underline-offset-2 cursor-pointer hover:text-orange-700 transition-colors"
              (click)="selectAll('a')">
              {{ selectAllALabel() }}
            </button>
          </th>
          <th class="text-right py-2 px-3 font-semibold text-(color:--text-secondary)">
            <div>{{ headerB() }}</div>
            @if (!isImport()) {
              <div class="font-normal text-(color:--text-primary) tabular-nums">{{ dateB() }}</div>
            }
            <button
              type="button"
              class="text-xs font-normal text-(--primary) underline underline-offset-2 cursor-pointer hover:text-orange-700 transition-colors"
              (click)="selectAll('b')">
              {{ selectAllBLabel() }}
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (row of measureRows(); track row.uid; let ri = $index) {
          <tr class="border-b border-(--border)" [class.bg-(--surface-1)]="ri % 2 === 1">
            <td class="py-2 px-3 align-top">
              <div class="flex items-center gap-1">
                @if (row.chosenSource !== null) {
                  <span class="material-symbols text-(--p-green-100) text-sm shrink-0">check</span>
                }
                <span class="font-medium truncate" [title]="row.conflict.measureName">{{ row.conflict.measureName }}</span>
              </div>
              @if (row.conflict.localisationName) {
                <div class="text-xs text-(color:--text-secondary) truncate ml-5" [title]="row.conflict.localisationName">{{
                  row.conflict.localisationName
                }}</div>
              }
            </td>
            <td colspan="2" class="p-0 align-top">
              <div class="flex" role="radiogroup" [attr.aria-label]="row.conflict.measureName">
                <button
                  type="button"
                  role="radio"
                  class="flex-1 w-1/2 py-2 px-3 text-right tabular-nums cursor-pointer transition-colors hover:bg-(--surface-2) focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-(color:--p-primary-color)"
                  [class.font-semibold]="row.chosenSource === 'a'"
                  [class.text-(color:--text-disabled)]="row.chosenSource === 'b'"
                  [attr.aria-checked]="row.chosenSource === 'a'"
                  [attr.tabindex]="row.chosenSource === 'b' ? -1 : 0"
                  (click)="setResolution(row.globalIndex, 'a')">
                  <!-- The row's own "value" parameter already matches measureName and stays unlabeled; any other
                       sub-variable (formula input, text, choice) keeps its label even alone in the row. -->
                  @for (param of row.conflict.parameters; track $index) {
                    @if (row.conflict.parameters.length > 1 || param.parameterKey !== 'value') {
                      <div class="flex items-baseline gap-(--gap-tight)">
                        <span class="flex-1 min-w-0 truncate text-left text-xs opacity-70" [title]="param.name">{{ param.name }}</span>
                        <span class="shrink-0">{{ param.valueA ?? '-' }}</span>
                      </div>
                    } @else {
                      <div>{{ param.valueA ?? '-' }}</div>
                    }
                  }
                </button>
                <button
                  type="button"
                  role="radio"
                  class="flex-1 w-1/2 py-2 px-3 text-right tabular-nums cursor-pointer transition-colors hover:bg-(--surface-2) focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-(color:--p-primary-color)"
                  [class.font-semibold]="row.chosenSource === 'b'"
                  [class.text-(color:--text-disabled)]="row.chosenSource === 'a'"
                  [attr.aria-checked]="row.chosenSource === 'b'"
                  [attr.tabindex]="row.chosenSource === 'b' ? 0 : -1"
                  (click)="setResolution(row.globalIndex, 'b')">
                  @for (param of row.conflict.parameters; track $index) {
                    @if (row.conflict.parameters.length > 1 || param.parameterKey !== 'value') {
                      <div class="flex items-baseline gap-(--gap-tight)">
                        <span class="flex-1 min-w-0 truncate text-left text-xs opacity-70" [title]="param.name">{{ param.name }}</span>
                        <span class="shrink-0">{{ param.valueB ?? '-' }}</span>
                      </div>
                    } @else {
                      <div>{{ param.valueB ?? '-' }}</div>
                    }
                  }
                </button>
              </div>
            </td>
          </tr>
        }
        @if (generalRows().length > 0) {
          <tr class="border-t-2 border-(--border)">
            <td colspan="3" class="py-2 px-3 text-xs font-semibold text-(color:--text-secondary) uppercase tracking-wide">
              {{ 'entities.campaign.tabs.general' | transloco }}
            </td>
          </tr>
          @for (row of generalRows(); track row.uid; let gi = $index) {
            <tr [class.bg-(--surface-1)]="gi % 2 === 1">
              <td class="py-2 px-3 align-top">
                <div class="flex items-center gap-1">
                  @if (row.chosenSource !== null) {
                    <span class="material-symbols text-(--p-green-100) text-sm shrink-0">check</span>
                  }
                  <span class="font-medium">{{ row.conflict.measureName }}</span>
                </div>
              </td>
              <td colspan="2" class="p-0 align-top">
                <div class="flex" role="radiogroup" [attr.aria-label]="row.conflict.measureName">
                  <button
                    type="button"
                    role="radio"
                    class="flex-1 w-1/2 py-2 px-3 text-right break-words cursor-pointer transition-colors hover:bg-(--surface-2) focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-(color:--p-primary-color)"
                    [class.font-semibold]="row.chosenSource === 'a'"
                    [class.text-(color:--text-disabled)]="row.chosenSource !== null && row.chosenSource !== 'a'"
                    [attr.aria-checked]="row.chosenSource === 'a'"
                    [attr.tabindex]="row.chosenSource === 'b' ? -1 : 0"
                    (click)="setResolution(row.globalIndex, 'a')">
                    <div class="line-clamp-2">{{ formatValue(row, row.conflict.parameters[0]?.valueA) }}</div>
                  </button>
                  <button
                    type="button"
                    role="radio"
                    class="flex-1 w-1/2 py-2 px-3 text-right break-words cursor-pointer transition-colors hover:bg-(--surface-2) focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-(color:--p-primary-color)"
                    [class.font-semibold]="row.chosenSource === 'b'"
                    [class.text-(color:--text-disabled)]="row.chosenSource !== null && row.chosenSource !== 'b'"
                    [attr.aria-checked]="row.chosenSource === 'b'"
                    [attr.tabindex]="row.chosenSource === 'b' ? 0 : -1"
                    (click)="setResolution(row.globalIndex, 'b')">
                    <div class="line-clamp-2">{{ formatValue(row, row.conflict.parameters[0]?.valueB) }}</div>
                  </button>
                </div>
              </td>
            </tr>
            @if (supportsConcat(row)) {
              <tr class="border-b border-(--border)" [class.bg-(--surface-1)]="gi % 2 === 1">
                <td></td>
                <td colspan="2" class="pb-2 px-3 text-right">
                  <button
                    type="button"
                    class="text-xs cursor-pointer transition-colors inline-flex items-center gap-1"
                    [class.text-(--primary)]="row.chosenSource === 'concat'"
                    [class.font-semibold]="row.chosenSource === 'concat'"
                    [class.text-(color:--text-disabled)]="row.chosenSource !== 'concat'"
                    [class.hover:text-(--primary)]="row.chosenSource !== 'concat'"
                    (click)="setResolution(row.globalIndex, 'concat')">
                    <span class="material-symbols text-sm">link</span>
                    {{ 'entities.campaign.merge.concatenate' | transloco }}
                    @if (row.chosenSource === 'concat') {
                      <span class="material-symbols text-sm text-(--primary)">check</span>
                    }
                  </button>
                </td>
              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>

  <div class="flex items-center justify-between gap-(--gap-normal) pt-(--space-6) px-(--space-2)">
    <div class="text-xs">
      @if (!allResolved()) {
        <span id="conflict-resolve-progress" class="text-amber-600"
          >{{ resolvedCount() }} / {{ conflictRows().length }} {{ 'entities.campaign.merge.resolvedProgress' | transloco }}</span
        >
      } @else {
        <span class="text-(--p-green-100) flex items-center gap-1">
          <span class="material-symbols text-sm">check_circle</span>
          {{ 'entities.campaign.merge.conflictsResolved' | transloco }}
        </span>
      }
    </div>
    <div class="flex items-center gap-(--gap-normal)">
      @if (showAbandonImport()) {
        <ces-delete-button [label]="'entities.campaign.actions.abandonImport' | transloco" (onClick)="abandonImport()" />
      }
      @if (showCancel()) {
        <ces-button-tertiary [label]="'common.buttons.cancel' | transloco" (onClick)="cancel()" />
      }
      <ces-button
        [label]="'common.buttons.validate' | transloco"
        icon="check"
        (onClick)="validate()"
        [disabled]="!allResolved()"
        [attr.aria-describedby]="!allResolved() ? 'conflict-resolve-progress' : null" />
    </div>
  </div>
</div>
